/**
 * Service de tracking de onboarding (factoring).
 * Thin wrappers sobre API.factoring.*.
 */

import API from "@/api";

export const ultimoPasoEmpresa = (empresaId: number | string, origen: string) =>
	(API as any).factoring.ultimoPasoEmpresa(empresaId, origen);

export const tranckingOnboarding = (
	origen: string,
	empresaId: number | string,
	ip: string | null,
	variable: string,
	info: unknown,
	facturas: unknown
) =>
	(API as any).factoring.tranckingOnboarding(origen, empresaId, ip, variable, info, facturas);
